// All API timestamps are server-generated in UTC. This module is the single place
// that interprets those UTC strings and hands back a Date whose getters (getHours,
// getDate, etc.) already reflect the browser's local timezone.

const HAS_TZ_DESIGNATOR = /(Z|[+-]\d{2}:?\d{2})$/i;

/**
 * Parses an API datetime string as UTC, even if the string is missing an explicit
 * "Z"/offset suffix (some legacy endpoints omit it, which would otherwise cause
 * `new Date(...)` to misinterpret the value as local time).
 */
const parseUtc = (value?: string | null): Date | null => {
    if (!value || typeof value !== 'string') return null;

    const normalized = HAS_TZ_DESIGNATOR.test(value.trim()) ? value : `${value}Z`;
    const parsed = new Date(normalized);

    return isNaN(parsed.getTime()) ? null : parsed;
};

export default { parseUtc };
